import {type BigId} from '@colonist/types'
import {type GetNotificationsData} from '../../../../shared/NotificationTypes.ts'
import {SocketLobbySend} from '../socket/SocketLobbySend.ts'
import {UIUtilsNotifications} from './UIUtilsNotifications.ts'
import {socket} from '../EntryShared.ts'

export class UINotificationSendHelper {
    private static readonly INITIAL_NOTIFICATION_COUNT: number = 25
    private static readonly LAZY_LOAD_NOTIFICATION_COUNT: number = 10

    static init() {
        socket.controller.registerSessionEstablishedObserver(() => {
            this.registerToNotificationServiceAndGetNotifications()
        })
    }

    static registerToNotificationServiceAndGetNotifications() {
        SocketLobbySend.registerToNotificationService()
        UIUtilsNotifications.delayNotificationDataRequest(() => this.getNotifications())
    }

    static getNotifications() {
        const getNotificationsData: GetNotificationsData = {
            date: new Date(),
            notificationCountToSend: this.INITIAL_NOTIFICATION_COUNT,
        }
        SocketLobbySend.getNotifications(getNotificationsData)
    }

    static sendMarkNotificationAsRead(notificationId: BigId) {
        SocketLobbySend.markNotificationAsRead(notificationId)
    }

    static sendMarkAllNotificationsAsRead() {
        SocketLobbySend.markAllNotificationsAsRead()
    }

    static getNotificationsAfterDate(date: Date) {
        const getNotificationsData: GetNotificationsData = {
            date: date,
            notificationCountToSend: this.LAZY_LOAD_NOTIFICATION_COUNT,
        }
        SocketLobbySend.getNotifications(getNotificationsData)
    }
}
